import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { SquaresFour, Wrench, LockKey, UsersFour, DownloadSimple, X, ChartLineUp, Megaphone, GearSix, Monitor } from "@phosphor-icons/react";
import { useAuth, api } from "../context/AuthContext";

const ITEMS = [
  { to: "/menu", label: "Dashboard", icon: SquaresFour, roles: ["user", "admin", "master"], testId: "sidebar-dashboard" },
  { to: "/analisi", label: "Analisi", icon: ChartLineUp, roles: ["master"], testId: "sidebar-analisi" },
  { to: "/marketing", label: "Marketing", icon: Megaphone, roles: ["master"], testId: "sidebar-marketing" },
  { to: "/monitor", label: "Monitor", icon: Monitor, roles: ["master"], testId: "sidebar-monitor" },
  { to: "/link", label: "Cassaforte", icon: LockKey, roles: ["master"], testId: "sidebar-cassaforte" },
  { to: "/manutenzione", label: "Manutenzione", icon: Wrench, roles: ["master"], testId: "sidebar-manutenzione" },
  { to: "/impostazioni", label: "Impostazioni", icon: GearSix, roles: ["master"], testId: "sidebar-impostazioni" },
  { to: "/admin", label: "Utenti", icon: UsersFour, roles: ["admin", "master"], testId: "sidebar-utenti" },
  { to: "/scarica", label: "Scarica", icon: DownloadSimple, roles: ["user", "admin", "master"], testId: "sidebar-scarica" },
];

export const Sidebar = ({ open, onClose }) => {
  const { user } = useAuth();
  const [webErrors, setWebErrors] = useState(0);
  const [unreadAlerts, setUnreadAlerts] = useState(0);
  const visible = ITEMS.filter((i) => i.roles.includes(user?.role || "user"));

  useEffect(() => {
    if (user?.role === "master") {
      api.get("/admin/web/alert-status").then(({ data }) => setWebErrors(data.errors || 0)).catch(() => {});
      api.get("/admin/alerts/unread-count").then(({ data }) => setUnreadAlerts(data.count || 0)).catch(() => {});
    }
  }, [user?.role]);

  return (
    <>
      {open && (
        <div data-testid="sidebar-backdrop" onClick={onClose}
          className="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm md:hidden" />
      )}
      <aside
        data-testid="sidebar"
        className={`fixed top-0 bottom-0 left-0 z-50 w-60 bg-surface-deep border-r border-white/10 flex flex-col transition-transform duration-300 pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)] overflow-y-auto ${open ? "translate-x-0" : "-translate-x-full"} md:translate-x-0`}
      >
        <div className="h-16 flex items-center justify-between px-6 border-b border-white/10">
          <NavLink to="/menu" data-testid="sidebar-logo" className="font-heading font-bold text-xl tracking-tighter text-white leading-none">
            AREAPAQ
            <span data-testid="sidebar-logo-subtitle" className="block text-[9px] tracking-[0.35em] font-medium text-white/40 mt-0.5">GESTIONALE</span>
          </NavLink>
          <button onClick={onClose} data-testid="sidebar-close-button" className="md:hidden text-white/50 hover:text-white">
            <X size={18} />
          </button>
        </div>
        <nav className="flex-1 py-6 px-3 space-y-1">
          {visible.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={item.testId}
                onClick={onClose}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 h-11 rounded-lg text-sm font-medium transition-colors duration-200 ${
                    isActive ? "bg-white text-black" : "text-white/60 hover:text-white hover:bg-white/5"
                  }`
                }
              >
                <Icon size={18} weight="duotone" /> {item.label}
                {item.to === "/menu" && unreadAlerts > 0 && (
                  <span data-testid="sidebar-alerts-badge" title={`${unreadAlerts} avvisi da controllare`}
                    className="ml-auto min-w-[18px] h-[18px] px-1 rounded-full bg-red-600 text-white text-[10px] font-bold inline-flex items-center justify-center leading-none">
                    {unreadAlerts > 99 ? "99+" : unreadAlerts}
                  </span>
                )}
                {item.to === "/monitor" && webErrors > 0 && (
                  <span data-testid="web-alert-dot" title={`${webErrors} sito/i in errore`}
                    className="ml-auto w-2 h-2 rounded-full bg-red-500 shadow-[0_0_6px_rgba(239,68,68,0.8)]" />
                )}
              </NavLink>
            );
          })}
        </nav>
        <div className="px-6 py-5 border-t border-white/10">
          <p className="text-[10px] tracking-[0.2em] uppercase text-white/30">Ruolo</p>
          <p className="text-xs text-white/60 mt-0.5 capitalize" data-testid="sidebar-role">{user?.role}</p>
        </div>
      </aside>
    </>
  );
};
